import { isNative } from '../platform/capacitor';
import { isLikelyApnsToken } from '../platform/notifications';
import { storageGet, storageSet } from '../platform/storage';
import { v2Request } from './client';

const SYNC_TOKEN_KEY = 'v2_push_sync_token';
const SYNC_MOBILE_KEY = 'v2_push_sync_mobile';

/** @param {{ deviceToken: string }} body */
export function syncPushTokenToBackend({ deviceToken }) {
  return v2Request('/api/auth/device-token', {
    method: 'POST',
    body: { deviceToken },
  });
}

/**
 * Sync FCM token to Pilot when mobile + token changed (native only, best-effort).
 * @param {{ mobile: string, deviceToken: string }} params
 */
export async function syncPushTokenIfNeeded({ mobile, deviceToken }) {
  if (!isNative() || !mobile || !deviceToken) return;
  if (isLikelyApnsToken(deviceToken)) return;

  const lastToken = await storageGet(SYNC_TOKEN_KEY);
  const lastMobile = await storageGet(SYNC_MOBILE_KEY);
  if (lastToken === deviceToken && lastMobile === mobile) return;

  try {
    await syncPushTokenToBackend({ deviceToken });
    await storageSet(SYNC_TOKEN_KEY, deviceToken);
    await storageSet(SYNC_MOBILE_KEY, mobile);
  } catch (err) {
    console.warn('[v2] push token sync failed', err?.message || err);
  }
}
